import { render, staticRenderFns } from "./channeling.vue?vue&type=template&id=11c89b6f&scoped=true"
import script from "./channeling.vue?vue&type=script&lang=js"
export * from "./channeling.vue?vue&type=script&lang=js"
import style0 from "./channeling.vue?vue&type=style&index=0&id=11c89b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c89b6f",
  null
  
)

export default component.exports